<div class="bg" style="background-image: url('../assets/fondo-alumnas.png'); background-size: cover; height:100vh">
  <router-outlet style="height:100% !important;"></router-outlet>
  <app-bloquear-pantalla></app-bloquear-pantalla>
</div>
